export enum ESidebarSize {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
}
